import api from "../../api/api";

//Modules Api
export const getAllModules = async (data) =>
  await api.get(`getAllModules/training/${data.usertype}/${data.language}`);

//Submodules Api

export const getAllSubModules = async (data) =>
  await api.get(
    `getAllSubmodulesByModuleid/training/${data.usertype}/${data.language}/${data.moduleid}`
  );

//Topics Api
export const getAllTopics = async (data) =>
  await api.get(
    `getAllTopicsBySubmoduleid/training/${data.usertype}/${data.language}/${data.moduleid}/${data.submoduleid}`
  );

//export const getAllContents = async (data) => await api.get(`getContentsAndQuizByTopicid/${data.usertype}/training/${data.moduleid}/${data.submoduleid}/${data.topicid}`);
export const getAllContents = async ({ topicid }) =>
  await api.get(`getContentsAndQuizByTopicid/${topicid}`);

export const updateAllContents = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);

//export const deleteAllContents = async (data) => await api.put(`updateMasterContentQuizData`, data);
export const deleteAllContents = async (data) =>
  await api.delete(
    `deleteMasterTchTrainingContent/${data.topicid}/${data.contentId}`
  );

export const getAllQuizContents = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);
export const createAllQuizContents = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);
export const deleteAllQuizs = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);
